/**
 * Type-safe Object.keys
 */
export function objectKeys(object) {
  return Object.keys(object);
}